module.exports = __webpack_public_path__ + "static/media/image.0828b2d4.svg";